import Auth0Service from './auth0-service'

export default new Auth0Service()
